import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[sukaList]'
})
// tslint:disable-next-line: directive-class-suffix
export class List {
  @HostBinding('class.list--ordered') get ordered() {
    if (this.nested) { return false; }
    return this.elementRef.nativeElement.tagName === 'OL';
  }

  @HostBinding('class.list--unordered') get unordered() {
    if (this.nested) { return false; }
    return this.elementRef.nativeElement.tagName === 'UL';
  }

  @HostBinding('class.list--nested') get nested() {
    return this.elementRef.nativeElement.parentElement.tagName === 'LI';
  }

  constructor(protected elementRef: ElementRef) { }
}
